import { packUUID } from "./utils";

export enum Routes {
  signup = "/signup",
  setupProfile = "/setup",
  setupProfileWithInviteCode = "/setup/:inviteCode",
  home = "/",
  homeTest = "/home-test",

  search = "/search",

  blends = "/blends",
  blend = "/blends/:resultId",

  deformulate = "/deformulate",
  results = "/results",
  result = "/results/:resultId",
  copyResult = "/results/:resultId/copy",

  pantry = "/pantry",

  profile = "/profile",
  helpCenter = "/help-center",
  appHelpCenter = "/app/help-center",

  internal = "/internal",
  internalSampleRequest = "/internal/sample-requests/:sampleRequestId",
  internalContactRequest = "/internal/contact-requests/:contactRequestId",
  internalFeaturedQueries = "/internal/featured-query",
  internalFeaturedQuery = "/internal/featured-query/:featuredQueryId",
  internalIngestionDraft = "/internal/ingestion-draft",
  internalOrganizationsAdmin = "/internal/organizations",
  internalOrganizationAdmin = "/internal/organizations/:organizationId",

  briefs = "/product-briefs",
  brief = "/product-briefs/:productBriefId",
  brief_deformulation = "/product-briefs/:productBriefId/deformulation/:deformulationId",

  virtualFormulation = "/virtual-formulation",
  virtualFormulationResult = "/virtual-formulation/:productBriefId",

  regulatory = "/regulatory",
  regulatoryDetail = "/regulatory/:substanceInputId",

  verify = "/verify",
  sampleRequests = "/sample-requests",

  rawMaterialProfile = "/raw-material/:rawMaterialName/:rawMaterialId",
  rawMaterialProfileAlias = "/raw-materials/:rawMaterialId",
  organizationRawMaterials = "/org/raw-materials",
  organizationRawMaterialProfile = "/org/raw-materials/:rawMaterialId",

  organizationProjects = "/org/projects",
  organizationProject = "/org/projects/:projectId",
  organizationProduct = "/org/projects/:projectId/products/:productId",
  organizationProjectTrial = "/org/projects/:projectId/products/:productId/trials/:trialId",

  billingCheckoutSuccess = "/billing/checkout-success",
  billingCheckoutCancel = "/billing/checkout-cancel",
}

export const getHomeRoute = () => {
  return Routes.home;
};

export const getSampleRequestsRoute = () => {
  return Routes.sampleRequests;
};

export const getResultsRoute = (resultId: string, defaultOpen?: number) => {
  if (defaultOpen === undefined) {
    return `${Routes.results}/${resultId}`;
  }
  return `${Routes.results}/${resultId}?defaultOpen=${defaultOpen}`;
};

export const getSetupProfileRoute = (inviteCode: string) => {
  return `${Routes.setupProfile}${inviteCode}`;
};

export const getBlendResultsRoute = (resultId: string) => {
  return `${Routes.blends}/${resultId}`;
};

export const getProductBriefRoute = (productBriefId: string) => {
  return `${Routes.briefs}/${productBriefId}`;
};

export const getVirtualFormulationResultRoute = (productBriefId: string) => {
  return `${Routes.virtualFormulation}/${productBriefId}`;
};

export const getProductBriefDeformulationRoute = (
  productBriefId: string,
  deformulationId?: string
) => {
  if (!deformulationId) {
    return `${Routes.briefs}/${productBriefId}`;
  }
  return `${Routes.briefs}/${productBriefId}/deformulation/${deformulationId}`;
};

export const getRegulatoryRoute = (substanceInputId?: string) => {
  if (!substanceInputId) {
    return Routes.regulatory;
  }
  return `${Routes.regulatory}/${substanceInputId}`;
};

export const getRawMaterialProfileRoute = (
  rawMaterialName: string,
  rawMaterialId: string
) => {
  return `/raw-material/${encodeURIComponent(rawMaterialName)}/${packUUID(
    rawMaterialId
  )}`;
};

export const getOrganizationRawMaterialProfileRoute = (
  organizationRawMaterialId: string
) => {
  return Routes.organizationRawMaterials + `/${organizationRawMaterialId}`;
};

export const getOrganizationProjectRoute = (projectId?: string) => {
  if (!projectId) {
    return Routes.organizationProjects;
  }
  return `${Routes.organizationProjects}/${projectId}`;
};

export const getOrganizationProductRoute = (
  projectId?: string,
  productId?: string
) => {
  if (!projectId) {
    return Routes.organizationProjects;
  }
  if (!productId) {
    return `${Routes.organizationProjects}/${projectId}`;
  }
  return `${Routes.organizationProjects}/${projectId}/products/${productId}`;
};

export const getOrganizationTrialRoute = (
  projectId: string,
  productId: string,
  trialId: string
) => {
  return `${Routes.organizationProjectTrial}`
    .replace(":projectId", projectId)
    .replace(":productId", productId)
    .replace(":trialId", trialId);
};

export const getInternalFeaturedQueryRoute = (featuredQueryId?: string) => {
  if (!featuredQueryId) {
    return Routes.internalFeaturedQueries;
  }
  return `${Routes.internalFeaturedQueries}/${featuredQueryId}`;
};

export const getInternalOrganizationRoute = (organizationId?: string) => {
  if (!organizationId) {
    return Routes.internalOrganizationsAdmin;
  }
  return `${Routes.internalOrganizationsAdmin}/${organizationId}`;
};

export const getInternalIngestionDraftRoute = () => {
  return Routes.internalIngestionDraft;
};
